import axios from "axios";
import React, {useEffect, useState} from "react";
import ProgressiveImage from 'react-progressive-image';
import Layout from "../components/Layout";
import Sectiontitle from "../components/Sectiontitle";
import Service from "../components/Service";
import {useTranslation} from "react-i18next";

function About() {
    const [toggler, setToggler] = useState(false);
    const [information, setInformation] = useState("");
    const [services, setServices] = useState([]);
    const [interessi, setInteressi] = useState([]);
    const {t} = useTranslation('common');

    const handleToggler = () => {
        setToggler({
            toggler: !toggler,
        });
    };

    useEffect(() => {
        axios.get("/api/information").then((response) => {
            setInformation(response.data);
        });
        axios.get("/api/services").then((response) => {
            setServices(response.data);
        });
        axios.get("/api/interessi").then((response) => {
            setInteressi(response.data);
        });
    }, []);

    return (
        <Layout>
            <div className="mi-about-area mi-section mi-padding-top">
                <div className="container">
                    <Sectiontitle title="whoiam.title"/>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mi-about-image">
                                <ProgressiveImage
                                    src={information.aboutImage}
                                    placeholder="/images/about-image-placeholder.png"
                                >
                                    {src => <img src={src} alt="aboutimage" onClick={() => handleToggler(!toggler)}/>}
                                </ProgressiveImage>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mi-about-content">
                                <h3>
                                    <span className="color-theme">{t(information.name)}</span>
                                </h3>
                                <p>{t('whoiam.first_par')}</p>
                                <p>{t('whoiam.second_par')}</p>
                                <p>{t('whoiam.third_par')}</p>
                                <p>{t('whoiam.fourth_par')}</p>
                                <ul>
                                    {!information.profiles ? null : (
                                        <li>
                                            <b>{t('whoiam.profile_title')}</b> {t(information.profiles)}
                                        </li>
                                    )}
                                    {!information.seniority ? null : (
                                        <li>
                                            <b>{t('whoiam.seniority_title')}</b> {t(information.seniority)}
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mi-service-area mi-section mi-padding-top mi-padding-bottom">
                <div className="container">
                    <Sectiontitle title="whoiam.core_business_title"/>
                    <div className="mi-service-wrapper">
                        <div className="row mt-30-reverse">
                            {services.map((service) => (
                                <div
                                    className="col-lg-4 col-md-6 col-12 mt-30"
                                    key={service.title}
                                >
                                    <Service content={service}/>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="mi-about-area mi-section mi-padding-bottom">
                <div className="container">
                    <Sectiontitle title="whoiam.personal_interests"/>
                    <div className="mi-service-wrapper">
                        <div className="row mt-30-reverse">
                            {interessi.map((interesse) => (
                                <div className="col-lg-4 col-md-6 col-12 mt-30" key={t(interesse.title)}>
                                    <div className="mi-service">
                                        <h5>{t(interesse.title)}</h5>
                                        <p>{t(interesse.details)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    );
}

export default About;
